<template>
  <Skeleton
    v-for="n in count"
    :key="`blog-teaser-skeleton-${n}`"
    type="custom"
    class="flex h-[570px] grow flex-col border-b border-primary px-6 py-5 pb-8 ring-1 ring-gray-tertiary md:h-[630px]"
  />
</template>

<script setup lang="ts">
type BlogTeaserSkeletonProps = {
  count?: number
}

withDefaults(defineProps<BlogTeaserSkeletonProps>(), {
  count: 4,
})
</script>
